// app/PostHogPageView.tsx
"use client";

import { usePathname, useSearchParams } from "next/navigation";
import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";

export default function PostHogPageView(): null {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const posthog = usePostHog();
  // Track pageviews
  useEffect(() => {
    if (
      !pathname ||
      !posthog ||
      typeof window === "undefined" ||
      searchParams.get("checkout_cancelled") === "true"
    ) {
      return;
    }

    const capturePageView = () => {
      let url = window.origin + pathname;
      if (searchParams.toString()) {
        url = url + `?${searchParams.toString()}`;
      }
      posthog.capture("$pageview", {
        $current_url: url,
      });
    };

    if (posthog.__loaded) {
      capturePageView();
      return;
    }

    window.addEventListener(
      "guestgallery:posthog-loaded",
      capturePageView,
      { once: true }
    );
    return () => {
      window.removeEventListener(
        "guestgallery:posthog-loaded",
        capturePageView
      );
    };
  }, [pathname, searchParams, posthog]);

  return null;
}
